// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba433958","453":"f820eccf","667":"316cec27"}[chunkId] + ".chunk.js";
};